import React from 'react'

const Contact = () => {
    return (
        <>
            <section className="main_slider">
                <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
                    <div className="carousel-inner">
                        <div className="carousel-item active">
                            <div className="inr_bnr_bg">
                                <img src="images/inrbnr.png" className="img-fluid" alt="..." />
                            </div>
                            <div className="carousel-caption">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className=" col-lg-6 col-md-8 col-sm-4 align-self-center">
                                            <div className="banner_text wow animate__animated animate__slideInLeft" data-wow-delay="0.3s" data-wow-duration="1s">
                                                <h1>Contact us</h1>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="contact_top all-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 wow animate__animated animate__fadeInLeft" data-wow-delay="0.2s">
                            <div className="cont_box">
                                <h3>Phone Number</h3>
                                <a href="tel:+1234567890">(123) 456 7890</a> - <a href="tel:+01234567890">0123 456 7890</a>
                            </div>
                        </div>
                        <div className="col-lg-4 wow animate__animated animate__fadeInUp" data-wow-delay="0.4s">
                            <div className="cont_box">
                                <h3>Email</h3>
                                <a href="mailto:info@domain.com">info@domain.com</a> - <a href="mailto:info@domain.com">info@domain.com</a>
                            </div>
                        </div>
                        <div className="col-lg-4 wow animate__animated animate__fadeInRight" data-wow-delay="0.6s">
                            <div className="cont_box">
                                <h3>Support</h3>
                                <a href="#">Consec Adipisicing Elit</a>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="contact_btm all-section-btm">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 wow animate__animated animate__fadeInDown" data-wow-delay="0.2s">
                            <div className="contact_btm_heading">
                                <h2>Contact us</h2>
                                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut
                                    labore et dolore magna aliqua. Ut
                                    enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip eat</p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12 wow animate__animated animate__fadeInUp" data-wow-delay="0.4s">
                            <div className="cont_form">
                                <form>
                                    <div className="row">
                                        <div className="col-lg-6 wow animate__animated animate__fadeInLeft" data-wow-delay="0.6s">
                                            <input type="text" placeholder="First Name" />
                                        </div>
                                        <div className="col-lg-6 wow animate__animated animate__fadeInRight" data-wow-delay="0.6s">
                                            <input type="text" placeholder="last Name" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-6 wow animate__animated animate__fadeInLeft" data-wow-delay="0.8s">
                                            <input type="text" placeholder="email" />
                                        </div>
                                        <div className="col-lg-6 wow animate__animated animate__fadeInRight" data-wow-delay="0.8s">
                                            <input type="text" placeholder="your email address" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-12 wow animate__animated animate__fadeInUp" data-wow-delay="1s">
                                            <input type="text" placeholder="What do you need support with" />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-12 wow animate__animated animate__fadeInUp" data-wow-delay="1.2s">
                                            <textarea placeholder="Message" defaultValue={""} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-12 text-center wow animate__animated animate__fadeInUp" data-wow-delay="1.4s">
                                            <button type="submit" className="theme_btn1">
                                                <div className="theme-btn-inner1">
                                                    <div className="btn-text1">Submit NOw</div>
                                                    <div className="btn-img1"><img src="images/btn-img2.png" alt />
                                                    </div>
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Contact